'use client';

import { forwardRef } from 'react';
import type { AlertProps as MantineAlertProps } from '@mantine/core';
import { Alert as MantineAlert } from '@mantine/core';

import type { LockedProps } from '../types';

export type AlertProps = Omit<MantineAlertProps, LockedProps>;

/**
 * ### Alert
 *
 * @description
 * Mantine's Alert minus per-call-site style overrides (see {@link LockedProps}).
 * There is no default icon; pass `icon=` explicitly where one is wanted.
 *
 * @example
 * ```tsx
 * <Alert color="yellow" title="Heads up">Please review before submitting.</Alert>
 * <Alert color="red">An error occurred.</Alert>
 * ```
 *
 * @param props - {@link AlertProps}
 * @returns React component
 */
const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MantineAlert {...props} ref={ref} />
));

Alert.displayName = 'Alert';

export default Alert;
